/* eslint-disable no-inner-declarations */
/* eslint-disable no-undef */
$(document).ready(function () {
    let tabs = document.querySelector('.product-tabs-section')
    let dest = document.querySelector('.product-section .product-tabs-destination')
    if (tabs && dest) {
        tabs.removeAttribute('data-shopify-editor-section')
        dest.appendChild(tabs)
        tabs.classList.remove('visually-hidden')
    }

    $('.tab-nav-item').click(function () {
        $('.tab-nav-item.active').not(this).removeClass('active')
        $(this).toggleClass('active')
        let idx = $('.tab-nav-item').index($(this))
        $('.tab-content-item')
            .not(':eq(' + idx + ')')
            .removeClass('active')
        $('.tab-content-item').eq(idx).toggleClass('active')
    })

    $('.faq_question').click(function () {
        if ($(this).parent().is('.open')) {
            $(this).closest('.faq').find('.faq_answer_container').animate({ height: '0' }, 300)
            $(this).closest('.faq').removeClass('open')
        } else {
            var newHeight = $(this).closest('.faq').find('.faq_answer').height() + 'px'
            $(this).closest('.faq').find('.faq_answer_container').animate({ height: newHeight }, 300)
            $(this).closest('.faq').addClass('open')
        }
    })

    if ($('.sistiexme-section').length > 0) {
        $('.sistiexme-section .grid__grid__item').click(function () {
            if ($(this).attr('prod-data') != undefined) {
                $('.sistiexme-section .image').css('background-image', 'url(' + $(this).attr('data-image') + ')')
                $('.sistiexme-section .image').removeClass('lazyloaded')
                $('.sistiexme-section .image').addClass('lazyload')
                $.getJSON('/products/' + $(this).attr('prod-data') + '.js', function (data) {
                    $('.sistiexme-section .product-image').attr('src', data.featured_image)
                    $('.sistiexme-section .product-link').attr('href', data.url)
                    $('.sistiexme-section .btn').attr('href', data.url)
                    $('.sistiexme-section .product-title').html(data.title)

                    $('.sistiexme-section .shopify-product-reviews-badge').attr('data-id', data.id)

                    $('#pageOverlay').addClass('is-visible')
                    $('html').addClass('no-scroll')
                    $('.sistiexme-section .popup').removeClass('hidden')

                    /* Reactivate review badges */
                    SPR.registerCallbacks()
                    SPR.initRatingHandler()
                    SPR.initDomEls()
                    SPR.loadProducts()
                    SPR.loadBadges()
                })
            }
        })

        $('.sistiexme-section .icon-close').click(function () {
            $('#pageOverlay').removeClass('is-visible')
            $('html').removeClass('no-scroll')
            $('.sistiexme-section .popup').addClass('hidden')
        })
    }

    // Product package page (Grafikr)
    if (document.querySelector('.js-package-product')) {
        var lastItem = document.querySelector('.js-last-item')
        var submitFake = document.querySelector('.js-submit-fake')
        var submitReal = document.querySelector('.js-submit-real')
        var packageItems = document.querySelectorAll('.js-item')
        var packageTotal = document.querySelector('.js-package-total')
        var itemSelects = document.querySelectorAll('.js-item-select')

        // Update variant prices
        for (var i = 0; i < itemSelects.length; i++) {
            itemSelects[i].addEventListener('change', function (e) {
                var currentSelect = e.currentTarget
                var selectedOption = currentSelect.options[currentSelect.selectedIndex]
                var newPrice = selectedOption.getAttribute('data-price')
                currentSelect.setAttribute('data-price', newPrice)

                var parentItem = $(currentSelect).closest('.js-item')
                var variantPrice = parentItem.find('.js-variant-price')
                variantPrice.html(theme.Currency.formatMoney(newPrice, theme.settings.moneyFormat))

                setTotalPrice()
            })
        }

        // Init price
        setTotalPrice()

        // Set total price function
        function setTotalPrice() {
            var price = 0
            for (var i = 0; i < packageItems.length; i++) {
                var currentItem = packageItems[i]
                if (currentItem.getAttribute('data-active') == 'true') {
                    price += parseInt(currentItem.querySelector('.js-item-select').getAttribute('data-price'))
                }
            }

            packageTotal.innerHTML = theme.Currency.formatMoney(price, theme.settings.moneyFormat)
        }

        // Toggle select items
        for (var i = 0; i < packageItems.length; i++) {
            packageItems[i].addEventListener('click', function (e) {
                // Only toggle if item selectable (i.e. available) and if not click on variant select
                if (
                    e.currentTarget.getAttribute('data-selectable') == 'true' &&
                    !e.target.classList.contains('js-item-select')
                ) {
                    var item = e.currentTarget
                    if (item.getAttribute('data-active') == 'true') {
                        item.setAttribute('data-active', 'false')
                        e.currentTarget.classList.remove('active')
                    } else {
                        item.setAttribute('data-active', 'true')
                        e.currentTarget.classList.add('active')
                    }

                    // Update price
                    setTotalPrice()

                    // Update fake submit (enable/disable)
                    var anySelected = false
                    for (var i = 0; i < packageItems.length; i++) {
                        if (packageItems[i].getAttribute('data-active') == 'true') {
                            anySelected = true
                            break
                        }
                    }

                    if (anySelected) {
                        submitFake.disabled = false
                    } else {
                        submitFake.disabled = true
                    }
                }
            })
        }

        // Click on fake submit
        submitFake.addEventListener('click', function (e) {
            e.currentTarget.classList.add('btn--loading')

            var items = []

            // Get all active items and store them in items array
            for (var i = 0; i < packageItems.length; i++) {
                var currentItem = packageItems[i]
                if (currentItem.getAttribute('data-active') == 'true') {
                    var variantId = currentItem.querySelector('.js-item-select').value
                    items.push({
                        quantity: 1,
                        id: parseInt(variantId),
                    })
                }
            }

            // Remove the last item from the array and insert its value in lastItem.
            // This is to be able to hook into the theme add to cart function
            // and run it with the last item.
            lastItem.value = items[items.length - 1].id
            items.pop()

            // Add the remaining items to cart, and run theme add to cart function when done
            if (items.length > 0) {
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    data: {
                        items: items,
                    },
                    success: added,
                    error: failed,
                })
            } else {
                added()
            }

            function added() {
                submitReal.click()
            }

            function failed(error) {
                alert('An error occurred:', error)
            }
        })
    }

    // Cart page
    if (document.querySelector('.js-cart-page')) {
        var giftBag = document.querySelector('.js-giftbag')

        // If giftbag in url parameter, check giftbag
        if (window.location.href.includes('?giftbag=true')) {
            giftBag.checked = true
        }

        var cartItems = document.querySelectorAll('.js-cart-item')
        var checkoutBtn = document.querySelector('.js-checkout-btn')

        checkoutBtn.addEventListener('click', function (e) {
            if (document.querySelector('#CartPageAgree').checked) {
                e.currentTarget.classList.add('btn--loading')

                var itemsToAdd = ''

                // Add all items and their qty to the string
                for (var i = 0; i < cartItems.length; i++) {
                    var variantId = cartItems[i].getAttribute('data-variant-id')
                    var qty = cartItems[i].querySelector('.js-item-qty').value
                    if (itemsToAdd == '') {
                        itemsToAdd += variantId + ':' + qty
                    } else {
                        itemsToAdd += ',' + variantId + ':' + qty
                    }
                }

                // If giftbag checked, add it to the string
                if (giftBag.checked) {
                    var variantId = giftBag.getAttribute('data-variant-id')
                    itemsToAdd += ',' + variantId + ':' + 1
                }

                // Redirect to checkout with contents of the proxy cart
                window.location.href = '/cart/' + itemsToAdd
            } else {
                //alert(theme.strings.cartTermsConfirmation)
                return false
            }
        })
    }

    // Cart drawer
    // Custom JS to prevent checkout without confirming terms and conditions
    // $('body').on('click', '.cart__checkout--ajax', function(evt) {
    //   if ($('#CartAgree').is(':checked')) {
    //   } else {
    //     alert(theme.strings.cartTermsConfirmation);
    //     $(this).removeClass('btn--loading');
    //     return false;
    //   }
    // });
})

{
    function visibleVideo(mediaQuery) {
        const allVideoElements = document.querySelectorAll('video')

        if (mediaQuery.matches) {
            // If media query matches
            allVideoElements.forEach((video) => {
                if (video.classList.contains('video-desktop')) {
                    video.classList.add('hidden')
                    if (video.classList.contains('active')) {
                        video.pause()
                    }
                } else {
                    video.classList.remove('hidden')
                    if (video.classList.contains('active')) {
                        video.play().catch(function (e) {
                            if (video.dataset.fallback && e.code === 0) {
                                const img = document.createElement('IMG')
                                img.src = video.dataset.fallback
                                img.role = 'presentation'
                                img.className = video.className

                                video.parentElement.replaceChild(img, video)
                            }
                        })
                    }
                }
            })
        } else {
            allVideoElements.forEach((video) => {
                if (video.classList.contains('video-mobile')) {
                    video.classList.add('hidden')
                    if (video.classList.contains('active')) {
                        video.pause()
                    }
                } else {
                    video.classList.remove('hidden')
                    if (video.classList.contains('active')) {
                        video.play().catch(function (e) {
                            if (video.dataset.fallback && e.code === 0) {
                                const img = document.createElement('IMG')
                                img.src = video.dataset.fallback
                                img.role = 'presentation'
                                img.className = video.className

                                video.parentElement.replaceChild(img, video)
                            }
                        })
                    }
                }
            })
        }
    }

    var mediaQuery = window.matchMedia('(max-width: 580px)')
    visibleVideo(mediaQuery) // Call listener function at run time
    mediaQuery.addEventListener('change', visibleVideo) // Attach listener function on state changes

    function playVideo(element) {
        const videoElements = element.querySelectorAll('video:not(.hidden)')

        videoElements.forEach((video) => {
            video.play().catch(function (e) {
                if (video.dataset.fallback && e.code === 0) {
                    const img = document.createElement('IMG')
                    img.src = video.dataset.fallback
                    img.role = 'presentation'
                    img.className = video.className

                    video.parentElement.replaceChild(img, video)
                }
            })
        })
    }

    function pauseVideo(element) {
        const videoElements = element.querySelectorAll('video')

        videoElements.forEach((video) => {
            video.pause()
        })
    }

    /**
     * video IntersectionObserver
     */

    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0,
    }

    let callback = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('intersecting')
                if (entry.target.classList.contains('intersection-video')) {
                    playVideo(entry.target)
                }
            } else {
                entry.target.classList.remove('intersecting')
                if (entry.target.classList.contains('intersection-video')) {
                    pauseVideo(entry.target)
                }
            }
        })
    }

    let videoIntersectionObserver = new IntersectionObserver(callback, options)
    /**
     * video IntersectionObserver - End
     */

    /**
     * Intersection videos
     */

    const intersectionVideos = document.querySelectorAll('.intersection-video')

    intersectionVideos.forEach((intersectionVideo) => {
        videoIntersectionObserver.observe(intersectionVideo)
    })

    /**
     * Intersection videos - End
     */

    /**
     * video Slider = play pause and more
     */

    const videoSlidecontainers = document.querySelectorAll('[data-video-slide]')

    videoSlidecontainers.forEach((videoSlidecontainer) => {
        const videoSlide = videoSlidecontainer.closest('.slideshow__slide')
        const videoElements = videoSlide.querySelectorAll('video')

        videoIntersectionObserver.observe(videoSlide)

        const targetNode = videoSlide
        // let isActive = targetNode.classList.contains('slick-active')

        function playVideos() {
            videoElements.forEach((video) => {
                video.classList.add('active')
                if (!video.classList.contains('hidden')) {
                    video.play().catch(function (e) {
                        if (video.dataset.fallback && e.code === 0) {
                            const img = document.createElement('IMG')
                            img.src = video.dataset.fallback
                            img.role = 'presentation'
                            img.className = video.className

                            video.parentElement.replaceChild(img, video)
                        }
                    })
                }
            })
        }

        function pauseVideos() {
            videoElements.forEach((video) => {
                video.classList.remove('active')
                if (video.style.block != 'none') {
                    video.pause()
                }
            })
        }

        // Options for the observer (which mutations to observe)
        const config = { attributes: true }

        // Callback function to execute when mutations are observed
        const oCallback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.attributeName == 'class') {
                    var currentClassState =
                        mutation.target.classList.contains('slick-active') &&
                        mutation.target.classList.contains('intersecting')
                    if (currentClassState) {
                        console.log('active!')
                        playVideos()
                        return
                    } else {
                        console.log('NOT active!')
                        pauseVideos()
                        return
                    }
                }
            }
        }

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(oCallback)

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config)
    })
}
